import NestedAttributes from './NestedAttributes';

export default NestedAttributes;
